export default "__VITE_ASSET__8904c10a__"